import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'
import { useUserStore } from '../stores/user-store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'orders',
        path: 'orders',
        component: () => import('../pages/admin/orders/OrdersPage.vue'),
      },
      {
        name: 'services',
        path: 'services',
        component: () => import('../pages/admin/services/ServicesPage.vue'),
      },
      {
        name: 'loyalty',
        path: 'loyalty',
        component: () => import('../pages/admin/loyalty/LoyaltyPage.vue'),
      },
      {
        name: 'clients',
        path: 'clients',
        component: () => import('../pages/admin/clients/ClientsPage.vue'),
      },
      {
        name: 'feedbacks',
        path: 'feedbacks',
        component: () => import('../pages/admin/feedbacks/FeedbacksPage.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/admin/settings/SettingsPage.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'marketing',
        path: 'marketing',
        component: () => import('../pages/admin/marketing/MarketingPage.vue'),
      },
      // {
      //   name: 'users',
      //   path: 'users',
      //   component: () => import('../pages/users/UsersPage.vue'),
      // },
      // {
      //   name: 'projects',
      //   path: 'projects',
      //   component: () => import('../pages/projects/ProjectsPage.vue'),
      // },
      // {
      //   name: 'payments',
      //   path: '/payments',
      //   component: RouteViewComponent,
      //   children: [
      //     {
      //       name: 'payment-methods',
      //       path: 'payment-methods',
      //       component: () => import('../pages/payments/PaymentsPage.vue'),
      //     },
      //     {
      //       name: 'billing',
      //       path: 'billing',
      //       component: () => import('../pages/billing/BillingPage.vue'),
      //     },
      //     {
      //       name: 'pricing-plans',
      //       path: 'pricing-plans',
      //       component: () => import('../pages/pricing-plans/PricingPlans.vue'),
      //     },
      //   ],
      // },
      // {
      //   name: 'faq',
      //   path: '/faq',
      //   component: () => import('../pages/faq/FaqPage.vue'),
      // },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to, from) => {
  const authStore = useUserStore()

  // 1. Проверяем авторизацию, если она нужна
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    try {
      // Пытаемся получить юзера по кукам
      await authStore.fetchUser()
    } catch (e) {
      console.error('Ошибка аутентификации:', e)
      return { name: 'login' } // В случае ошибки — на логин
    }

    // Если после запроса всё еще не авторизован — на логин
    if (!authStore.isAuthenticated) {
      return { name: 'login' }
    }
  }

  // 2. Проверяем права доступа (permissions)
  if (to.meta.permission) {
    // Если юзер загружен, но прав нет — на дашборд или 403
    if (!authStore.can(to.meta.permission)) {
      return { name: 'dashboard' }
    }
  }

  // 3. Если всё ок — разрешаем переход
  return true
})

export default router
